export default __webpack_public_path__ + "static/media/bg2.561b23be.jpg";